import React from 'react';
import {Box, Typography, useTheme} from '@mui/material';
import AgingBadge from "../AgingBadge";
import TwoDecimalsMoneyRenderer from "../../../utils/TwoDecimalsMoneyRenderer";

export default function CustomerContextPanel({paymentTrackRecord, debtSummary}) {
    const theme = useTheme();
    const customerSince = paymentTrackRecord.customerSince || 'Sin dato';
    const lastPayment = debtSummary.lastPayment;
    const lastPaymentDescription = lastPayment.paidOn
        ? `${lastPayment.paidOn} · ${TwoDecimalsMoneyRenderer(lastPayment.amount.amount)}`
        : 'Sin pagos';

    return (
        <Box sx={{border: `1px solid ${theme.palette.divider}`, borderRadius: '8px', p: 2}}>
            <Typography variant="subtitle2" sx={{mb: 1}}>Cliente</Typography>
            <SummaryLine label="Cliente desde" value={customerSince}/>
            <SummaryLine label="Facturas pagadas" value={paymentTrackRecord.paidInvoices}/>
            <SummaryLine label="Pagos atrasados" value={paymentTrackRecord.latePaidInvoices}/>
            <SummaryLine label="Facturas por vencer" value={paymentTrackRecord.upcomingInvoices}/>
            <SummaryLine label="Deuda total" value={TwoDecimalsMoneyRenderer(debtSummary.totalDebt.amount)}/>
            <SummaryLine label="Deuda vencida" value={TwoDecimalsMoneyRenderer(debtSummary.overdueDebt.amount)}/>
            {debtSummary.isInAnOverdueTier &&
                <Box sx={{display: 'flex', justifyContent: 'flex-end', py: 0.5}}>
                    <AgingBadge tierCode={debtSummary.worstTier.code} label={debtSummary.worstTier.label} theme={theme}/>
                </Box>}
            <SummaryLine label="Último pago" value={lastPaymentDescription}/>
        </Box>
    );
}

function SummaryLine({label, value}) {
    return (
        <Box sx={{display: 'flex', justifyContent: 'space-between', py: 0.5}}>
            <Typography variant="body2">{label}</Typography>
            <Typography variant="body2" sx={{fontWeight: 600}}>{value}</Typography>
        </Box>
    );
}
